export const PermissionShipping = {
    PUT: "mgr-shipping-**-PUT",
    POST: "mgr-shipping-POST",
    DELETE: "mgr-shipping-**-DELETE",
    GET: "mgr-shipping-search-GET",
    GET_UUID: "mgr-shipping-**-GET"
};